import theme from 'utils/styles/theme';
import { createGlobalStyle } from 'styled-components';

import fontItalicW2 from '../../fonts/AkkuratPro-Italic.woff2';
import fontBoldItalicW2 from '../../fonts/AkkuratPro-BoldItalic.woff2';
import fontRegularW2 from '../../fonts/AkkuratPro-Regular.woff2';
import fontRegularBoldW2 from '../../fonts/AkkuratPro-Bold.woff2';

import fontItalic from '../../fonts/AkkuratPro-Italic.woff';
import fontBoldItalic from '../../fonts/AkkuratPro-BoldItalic.woff';
import fontRegular from '../../fonts/AkkuratPro-Regular.woff';
import fontRegularBold from '../../fonts/AkkuratPro-Bold.woff';

import fontLight from '../../fonts/AkkuratLightPro-Regular.woff';
import fontLightW2 from '../../fonts/AkkuratLightPro-Regular.woff2';

import circularFontBlack from '../../fonts/CircularStd-Black.woff';
import circularFontBlack2 from '../../fonts/CircularStd-Black.woff2';
import circularFontBold from '../../fonts/CircularStd-Bold.woff';
import circularFontBold2 from '../../fonts/CircularStd-Bold.woff2';

const Global = createGlobalStyle`

@font-face {
    font-family: 'CircularStd';
    src: url(${circularFontBlack2}) format('woff2'),
        url(${circularFontBlack}) format('woff');
    font-weight: bold;
    font-style: normal;
}

@font-face {
    font-family: 'CircularStd';
    src: url(${circularFontBold2}) format('woff2'),
        url(${circularFontBold}) format('woff');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'Akkurat Pro';
    src: url(${fontBoldItalicW2}) format('woff2'),
        url(${fontBoldItalic}) format('woff');
    font-weight: bold;
    font-style: italic;
}

@font-face {
    font-family: 'Akkurat Pro';
    src: url(${fontItalicW2}) format('woff2'),
        url(${fontItalic}) format('woff');
    font-weight: normal;
    font-style: italic;
}

@font-face {
    font-family: 'Akkurat Pro';
    src: url(${fontBoldItalicW2}) format('woff2'),
        url(${fontBoldItalic}) format('woff');
    font-weight: bold;
    font-style: italic;
}

@font-face {
    font-family: 'Akkurat Pro';
    src: url(${fontLightW2}) format('woff2'),
        url(${fontLight}) format('woff');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'Akkurat Pro';
    src: url(${fontRegularBoldW2}) format('woff2'),
        url(${fontRegularBold}) format('woff');
    font-weight: bold;
    font-style: normal;
}

    html, body {
        cursor: ${theme.cursor.idle};


        font-size: 18px;
        
        @media screen and (max-width: 560px){
            font-size: 16px;
        }
        @media screen and (max-width: 400px){
            font-size: 12px;
        }

    }
	body {
		background: ${theme.colors.primary};
		min-height: 100vh;
        max-height: 100vh;
        font-family: ${theme.fonts.sansSerif};
        color: ${theme.colors.client.fontColor};
    }


    h1, h2, h3, h4 {
        font-family: ${theme.fonts.headline};
    }

    a, span {
        color: ${theme.colors.accent};

    }

    a {
        color: unset;
        text-decoration: initial;
    }
`;

export default Global;
